import React from 'react';
import styled from 'styled-components';
import videoSrc from '../../videos/TURO_nagranie_ekranu.mp4';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import media from 'constants/styles/media';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { Button } from 'components/button';
import colors from 'src/constants/styles/colors';
import layout from 'src/constants/styles/layout';
import { SECTION_IDS, SECTION_PATHS } from 'constants/index';

const SIntroSection = styled.section`
    width: 100%;
    margin-top: ${layout.headerHeight};
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: space-between;
    padding-top: 96px;

    @media (max-width: ${media.tablet}) {
        margin-top: ${layout.headerHeightMobile};
        flex-direction: column;
        padding-top: 36px;
        gap: 36px;
    }
`;

const STextWrapper = styled.div`
    max-width: 437px;
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    @media (max-width: ${media.tablet}) {
        max-width: none;
    }
`;

const STextWrapperMotto = styled.p`
    font-weight: 500;
    font-size: 20px;
    line-height: 1;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: ${colors.gray_90};
    margin-bottom: 16px;
`;

const STextWrapperHeader = styled.h1`
    font-weight: 700;
    font-size: 48px;
    line-height: 1;
    letter-spacing: 0.01em;
    color: ${colors.gray_90};
    @media (max-width: ${media.tablet}) {
        font-size: 36px;
    }
`;

const STextWrapperDescription = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.03em;
    color: ${colors.gray_90};
    margin: 36px 0 72px 0;
    @media (max-width: ${media.tablet}) {
        margin: 36px 0 48px 0;
    }
`;

const SAnchorWrapper = styled.div`
    width: 100%;
    @media (max-width: ${media.tablet}) {
        display: flex;
        justify-content: center;
    }
`;

const SButton = styled(Button)`
    width: 340px;
`;

const SVideoWrapper = styled.div`
    max-width: 624px;
    width: 100%;
`;

const SVideo = styled.video`
    width: 100%;
    height: auto;
    border-radius: 16px;
`;

export const IntroSection = () => {
    const { t } = useTranslation();

    return (
        <SIntroSection id={SECTION_IDS.HOME}>
            <STextWrapper>
                <STextWrapperMotto>{t('index-page.motto')}</STextWrapperMotto>
                <STextWrapperHeader>{t('index-page.header')}</STextWrapperHeader>
                <STextWrapperDescription>{t('index-page.description')}</STextWrapperDescription>
                <SAnchorWrapper>
                    <AnchorLink to={SECTION_PATHS.FOOTER}>
                        <SButton title={t('index-page.meeting-button')} />
                    </AnchorLink>
                </SAnchorWrapper>
            </STextWrapper>
            <SVideoWrapper>
                <SVideo autoPlay muted loop playsInline>
                    <source src={videoSrc} type="video/mp4" />
                </SVideo>
            </SVideoWrapper>
        </SIntroSection>
    );
};
